import Vue from 'vue';
import VueFullscreen from 'vue-fullscreen';

Vue.use(VueFullscreen);
